import Header from './Header.js';
import Home from './Home.js';
import About from './About.js';
import Playlist from './Playlist.js';
import Album from './Album.js';
import Book from './Book.js';
import BookChapter from './BookChapter.js';
import Videos from './Videos.js';
import Contact from './Contact.js';
import Policy from './Policy.js';
import NoMatch from './NoMatch.js';
import Layout from './Layout.js';
import Blog from './Blog.js';
import BlogDetails from './BlogDetails.js';
import Bespoke from './Bespoke.js';
import Sync from './Sync.js';


import { Routes, Route, BrowserRouter } from 'react-router-dom';

import './App.css';




function App() {

  return (

    < BrowserRouter >
      <Layout>
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/album" element={<Album />} />
          <Route path="/playlist" element={<Playlist />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Policy />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="blog/:slug" element={<BlogDetails />} />
          <Route path="/book" element={<Book />} />
          <Route path="book/:slug" element={<BookChapter />} />
          <Route path="/bespoke" element={<Bespoke />} />
          <Route path="/sync" element={<Sync />} />
          <Route path="*" element={<NoMatch />} />

        </ Routes >
      </Layout>
    </ BrowserRouter >
  );
}

export default App;

